import { Box, Group, Text, Tooltip } from '@mantine/core';
import { IconAlertTriangle, IconInfoCircle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

export interface ModalEditorItemBaseProps {
    label?: string;
    labelWidth?: number;
    tooltip?: string;
    children: ReactNode;
    error?: ReactNode;
    submitChanges?: () => Promise<void> | Promise<boolean | void> | void;
    required?: boolean;
}

export const ModalEditorItemBase = ({
    label,
    labelWidth,
    tooltip,
    children,
    error,
    submitChanges,
    required = false,
}: ModalEditorItemBaseProps) => {
    const handleBlur = () => {
        submitChanges?.();
    };

    const labelGroup = label ? (
        <Group gap={4} w={labelWidth}>
            <Text size="xs" fw={required ? 600 : 400}>
                {label}
            </Text>
            {tooltip && (
                <Tooltip label={tooltip}>
                    <IconInfoCircle size={12} color="var(--mantine-color-text)" />
                </Tooltip>
            )}
        </Group>
    ) : null;

    return (
        <Group flex={'flex-start'} gap={4} justify="space-between">
            {labelGroup}
            <Box flex={3} onBlur={handleBlur} onKeyDown={(e) => e.key === 'Enter' && submitChanges?.()}>
                {children}
            </Box>
            <Box w={4}>
                {error && (
                    <Tooltip label={error}>
                        <IconAlertTriangle size={12} color="red" />
                    </Tooltip>
                )}
            </Box>
        </Group>
    );
};
